import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reingreso-inscripcion-completa',
  templateUrl: './reingreso-inscripcion-completa.component.html',
  styleUrls: ['./reingreso-inscripcion-completa.component.scss']
})
export class ReingresoInscripcionCompletaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
